import ReactPlayer from "react-player"
import styled from "styled-components"
const Styled = {
  PlayerWrapper: styled.div<{ $noMargin: boolean; $setAbsolute: boolean }>`
    height: 100%;
    margin-top: ${(p) => (p.$noMargin ? "0" : "52px")};
    position: relative;
    ${(p) =>
      !p.$setAbsolute
        ? ""
        : `position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;`}
  `,
  ReactPlayer: styled(ReactPlayer).attrs({
    muted: true,
    controls: true,
  })`
    margin: 0 auto;
    max-width: 100%;
  `,
}

interface YouTubePlayerProps {
  url: string
  width?: string | number
  height?: string | number
  playing?: boolean
  noMargin?: boolean
  setAbsolute?: boolean
}

export default function YouTubePlayer(props: YouTubePlayerProps) {
  return (
    <Styled.PlayerWrapper
      $noMargin={props.noMargin}
      $setAbsolute={props.setAbsolute}
    >
      <Styled.ReactPlayer
        url={props.url}
        width={props.width}
        height={props.height}
        playing={props.playing}
      />
    </Styled.PlayerWrapper>
  )
}
